import { MasterEndPoints, pageNo } from "../../config";
import { getQueryStringFrmObject, postApi, getApi, deleteApi } from "../helpers/utility";

class MasterApi {
  create = async (masterPojo) => {
    console.log("masterpojo", masterPojo);
    if (masterPojo) {
      //   console.log("Master pojo", JSON.stringify(masterPojo));
      var result = await postApi(MasterEndPoints.add, masterPojo);
      return result;
    }
  };

  read = async (readFilter, page) => {
    let finalListEndPoint;
    finalListEndPoint = MasterEndPoints.list + "?pageNo=" + page + "&per_page=" + pageNo;
    let searchParams = { info: readFilter };
    if (searchParams.info) {
      var queryString = getQueryStringFrmObject(searchParams);
      finalListEndPoint = finalListEndPoint + "&" + queryString;
    }
    var result = await getApi(finalListEndPoint);
    return result;
  };

  findById = async (masterId) => {
    var result = await getApi(MasterEndPoints.findById, masterId);
    return result;
  };

  delete = async (masterPojo) => {
    console.log("masterpojo", masterPojo);
    if (masterPojo) {
      var result = await deleteApi(MasterEndPoints.delete, masterPojo);
      return result;
    }
  };

}
export default new MasterApi();
